import React, { Suspense } from "react";
import PrivateRoute from "./PrivateRoute";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import Home from "../components/SuperAdmin/Home/Home";
import { Navigate, Route, Routes } from "react-router-dom";
import LazyLoader from "../components/common/commonComponents/LazyLoader/LazyLoader";

const Chat = React.lazy(() => import("../pages/SuperAdmin/Chat/Chat"));
const Users = React.lazy(() => import("../pages/SuperAdmin/Users/Users"));
const Updates = React.lazy(() => import("../pages/SuperAdmin/Updates/Updates"));
const Ratings = React.lazy(() => import("../pages/SuperAdmin/Ratings/Ratings"));
const MyProfile = React.lazy(() => import("../components/MyProfile/MyProfile"));
const Dashboard = React.lazy(() => import("../pages/SuperAdmin/Dashboard/Dashboard"));
const Scheduler = React.lazy(() => import("../pages/SuperAdmin/Scheduler/Scheduler"));
const Schedule = React.lazy(() => import("../pages/SuperAdmin/Scheduler/Schedule/Schedule"));
const JobRequest = React.lazy(() => import("../pages/SuperAdmin/PropertyManager/JobRequest"));
const Action = React.lazy(() => import("../pages/SuperAdmin/CategoryManagement/Action/Action"));
const Questionnaire = React.lazy(() => import("../pages/SuperAdmin/Questionnaire/Questionnaire"));
const AllActivities = React.lazy(() => import("../pages/SuperAdmin/AllAcitvities/AllActivities"));
const PropertyManager = React.lazy(() => import("../pages/SuperAdmin/PropertyManager/PropertyManager"));
const StaffManagement = React.lazy(() => import("../pages/SuperAdmin/StaffManagement/StaffManagement"));
const CategoryManagement = React.lazy(() => import("../pages/SuperAdmin/CategoryManagement/CategoryManagement"));
const ServiceRequests = React.lazy(() => import("../pages/SuperAdmin/CategoryManagement/ServiceRequests/ServiceRequests"));
const CategoryManagementRoutes = React.lazy(() => import("../pages/SuperAdmin/CategoryManagement/CategoryManagementRoutes"));
const Groups = React.lazy(() => import("../pages/SuperAdmin/Scheduler/Groups/Groups"));
const QuestionnaireRoutes = React.lazy(() => import("../pages/SuperAdmin/Questionnaire/QuestionnaireRoutes"));
const Questions = React.lazy(() => import("../pages/SuperAdmin/Questionnaire/Questions/Questions"));

const MainRouter = ({ props }) => {
  const { loader } = props;
  let permissions = useSelector((state) => state.user?.permissions);

  if (!permissions) permissions = [""];

  return (
    <div className="main_container">
      <Suspense fallback={<LazyLoader />}>
      <Routes>
        <Route
          path="/home"
          exact
          element={
            // only Home outlet is wrapped in private routing, no need of checking again and again...
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        >
          <Route path="activity" exact element={<AllActivities />} />
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Dashboard")) && (
              <Route path="dashboard" exact element={<Dashboard />} />
            )}
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Scheduler")) && (
              <>
                <Route path="scheduler" exact element={<Scheduler />} />
                <Route path="scheduler/schedule" exact element={<Schedule />} />
                <Route path="scheduler/groups" exact element={<Groups />} />
              </>
            )}
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Chat")) && (
              <Route path="chat" exact element={<Chat />} />
            )}
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Updates")) && (
              <Route path="updates" exact element={<Updates />} />
            )}
          {permissions &&
            (permissions[0] === "All" ||
              permissions.includes("Property Manager")) && (
              <>
                <Route
                  path="propertyManager"
                  exact
                  element={<PropertyManager />}
                />
                <Route
                  path="propertymanager/jobrequest"
                  exact
                  element={<JobRequest />}
                />
              </>
            )}
          {permissions &&
            (permissions[0] === "All" ||
              permissions.includes("Category Management")) && (
              <Route
                path="categoryManagement"
                exact
                element={<CategoryManagementRoutes />}
              >
                <Route path="" exact element={<CategoryManagement />} />
                <Route
                  path="serviceRequests"
                  exact
                  element={<ServiceRequests />}
                />
                <Route path="action" exact element={<Action />} />
              </Route>
            )}
          {permissions &&
            (permissions[0] === "All" ||
              permissions.includes("Staff Management")) && (
              <Route path="staff" exact element={<StaffManagement />} />
            )}
          {permissions &&
            (permissions[0] === "All" ||
              permissions.includes("Questionnaire")) && (
              <Route
                path="questionnaire"
                exact
                element={<QuestionnaireRoutes />}
              >
                <Route path="" exact element={<Questionnaire />} />
                <Route path="questions" exact element={<Questions />} />
              </Route>
            )}
          {permissions &&
            (permissions[0] === "All" ||
              permissions.includes("User and Access")) && (
              <Route path="users" exact element={<Users />} />
            )}
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Ratings")) && (
              <Route path="ratings" exact element={<Ratings />} />
            )}
          {permissions &&
            (permissions[0] === "All" || permissions.includes("Dashboard")) && (
              <Route
                path="/home"
                exact
                element={<Navigate replace to="/home/dashboard" />}
              />
            )}
          <Route path="profile" exact element={<MyProfile />} />

          {/* default path for auth routes... */}
          <Route path="*" exact element={<Navigate to="dashboard" replace />} />
        </Route>
        {/* )} */}

        {/* default redirection - without auth no pvt should hit... */}
        <Route
          path="*"
          element={
            <PrivateRoute>
              <Navigate replace to="/home/dashboard" />
            </PrivateRoute>
          }
        />
      </Routes>
      </Suspense>
      <ToastContainer position="top-right" />
    </div>
  );
};

export default MainRouter;
